module.exports = __webpack_public_path__ + "static/media/poppins-500.792477d0.woff2";